var auth = (function() {

	var accessToken = null;
	var refreshToken = null;
	var accessTokenExpiresAt = null;
	const ACCESS_TOKEN_EXPIRES_AT_LEEWAY_SECONDS = 5

	let load = () => {
		accessToken = window.localStorage.getItem('ACCESS_TOKEN')
		refreshToken = window.localStorage.getItem('REFRESH_TOKEN')
		accessTokenExpiresAt = window.localStorage.getItem('ACCESS_TOKEN_EXPIRES_AT')
	}

	let setAccessTokenExpiresIn = (expiresIn) => 
		setAccessTokenExpiresAt(
            (new Date()).getTime() +
            (expiresIn * 1000)
        )

	let setAccessTokenExpiresAt = (expiresAt) => {
		accessTokenExpiresAt = expiresAt
		if (expiresAt === null) {
			window.localStorage.removeItem('ACCESS_TOKEN_EXPIRES_AT')	
			return
		}
		window.localStorage.setItem('ACCESS_TOKEN_EXPIRES_AT', expiresAt)
	}

	let setAccessToken = (token) => {
		accessToken = token
		if (token === null) {
			window.localStorage.removeItem('ACCESS_TOKEN')	
			return
		}
		window.localStorage.setItem('ACCESS_TOKEN', token)
	}
	
	let setRefreshToken = (token) => {
		refreshToken = token
		if (token === null) {
			window.localStorage.removeItem('REFRESH_TOKEN')	
			return
		}
		window.localStorage.setItem('REFRESH_TOKEN', token)
	}

	let isRefreshNeeded = () => {
		return (new Date()).getTime() >= 
			(accessTokenExpiresAt - ACCESS_TOKEN_EXPIRES_AT_LEEWAY_SECONDS)
	}

	// Load:
	load()

	return {
		setAccessToken: setAccessToken,
		setRefreshToken: setRefreshToken,
		setAccessTokenExpiresIn: setAccessTokenExpiresIn,
		isRefreshNeeded: isRefreshNeeded,
		getAccessToken: () => {
			return accessToken
		},
		getRefreshToken: () => {
			return refreshToken
		},
		hasLoggedIn: () => {
			return accessToken != null
		},
		logout: () => {
			setAccessToken(null)
			setRefreshToken(null)
			setAccessTokenExpiresAt(null)

			var r = document.querySelector(':root');
			// Set it:
			r.style.setProperty('--primary', '#edbe15');
		}
	}


})()

export default auth